// import { useEffect, useRef } from 'react';
import { useMemoizedFn } from 'ahooks';
import classNames from 'classnames';
import Split from 'react-split';
// import PartTitle from '../../../components/PartTitle';
import { IMainContentWriting } from '@/utils/ctype';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

import './index.less';


export default function MainContent(props: IMainContentWriting) {
  const { pageData, saveAnswerHandle, boxStyle, index, value, isAI} = props;
  const {content, img_url, frontContent, afterContent} = pageData.question;

  const handleInput = useMemoizedFn((event: React.FormEvent<HTMLTextAreaElement>) => {
    if (isAI) {
      return;
    }
    const mapKey = ['essay', 'big_essay'] ;
    const {value} = event.target as HTMLTextAreaElement;
    saveAnswerHandle({key: mapKey[index], value });
  });

  return (
    <div className={style.exercises} style={boxStyle}>
      <Split gutterSize={2} className={style.writingBox} dragInterval={1}>
        <div className={classNames(style.articleBox)} >
          {
            frontContent ? 
              <div className={style.frontcontent} data-key={'question.frontContent'}>
                <HtmlParser htmlString={frontContent}></HtmlParser>
              </div> : null
          }
          {
            content ? 
              <div className={classNames(style.content, index === 0 ? '' : style.bigContent)} data-key={'question.content'}>
                {
                  content.split('\n').map((s) => <p key={s}><HtmlParser htmlString={s}></HtmlParser></p>)
                }
              </div> : null
          }
          {
            afterContent ? 
              <div className={style.aftercontent} data-key={'question.afterContent'}>
                {
                  afterContent.split('\n').map((s) => <p key={s}><HtmlParser htmlString={s}></HtmlParser></p>)
                }
              </div> : null
          }
          {
            img_url? 
              <img src={img_url} className={style.picture} alt="Writing task diagram" /> : null
          }
        </div>
        <div className={classNames(style.answer)} id={`question${index+1}`}>
          {
            isAI && !value ? <div className={style.answerTitle}>{'你没有写任何内容'}</div> : null
          }
          <div className={style.answerWrapper}>
            <div className={style.textAreaWrapper} data-disabled={isAI}>
              <textarea disabled={isAI} spellCheck={false} className={style.textArea} value={value} onInput={handleInput}></textarea>
            </div>
            <div className={style.wordCount}>Word count: {value ? value.split(/\s+/).filter((item: string) => item).length : 0}</div>
          </div>
        </div>
      </Split>
    </div>
  );
  
}
